import {
    CustomAlarmListItem,
    CustomAlarmModalTextContent,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { CUSTOM_ALARM_DELETION_TEXTS } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-deletion-confirmation-modal/custom-alarm-deletion-confirmation-modal.constants';

export const getCustomAlarmDeletionTexts = (alarmDefinitions: CustomAlarmListItem[]): CustomAlarmModalTextContent => {
    const mode = alarmDefinitions.length === 1 ? 'single' : 'multiple';

    return CUSTOM_ALARM_DELETION_TEXTS[mode];
};
